import { useLocation, useNavigate } from 'react-router-dom';
import queryString from 'query-string';
import { useEffect } from 'react';
import { routes } from 'app/routing/routesConfig';

export const useAppRedirect = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { launchApp, ...rest } = queryString.parse(location.search);
  const shouldLaunchApp = launchApp === 'true';
  useEffect(() => {
    if (shouldLaunchApp) {
      const finalQueryParams = { ...rest, path: location.pathname };
      navigate(
        {
          pathname: routes.appRedirect.path,
          search: queryString.stringify(finalQueryParams),
        },
        { replace: true }
      );
    } else if (launchApp) {
      navigate({ search: queryString.stringify(rest) }, { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
